import * as f from "./fields";
import { CustomerContractSnapshotTypes } from "@graphql";

export const defaultFields = [
  f.customer,
  // f.consultant,
  f.responsiblePerson,
  f.invoiceMarking,
  f.contactPerson
];

export const contracts = {
  [CustomerContractSnapshotTypes.Framework]: [defaultFields]
};
